import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ButtonModule } from "../button/index";
import { DialogModule } from "../dialog/index";
import { DrawerModule } from "../drawer/index";
import { DropdownModule } from "../dropdown/index";
import { GenericModule } from "../generic/index";
import { IconModule } from "../icon/index";
import { MediaModule } from "../media/index";
import { PopoverModule } from "../popover/index";
import { PrintModule } from "../print/index";
import { TemplateModule } from "../template/index";
import { ToastModule } from "../toast/index";

import { LayoutComponent } from "./layout.component";
import { LayoutHeaderComponent } from "./components/header.component";
import { LayoutHeaderMenuComponent } from "./components/header/menu.component";
import { LayoutSidebarComponent } from "./components/sidebar.component";
import { LayoutSidebarTogglerComponent } from "./components/sidebar/toggler.component";
import { LayoutSidebarAvatarComponent } from "./components/sidebar/avatar.component";
import { LayoutSidebarBrandComponent } from "./components/sidebar/brand.component";
import { LayoutSidebarHeaderComponent } from "./components/sidebar/header.component";
import { LayoutSidebarFooterComponent } from "./components/sidebar/footer.component";
import { LayoutNavComponent } from "./components/nav.component";
import { LayoutNavItemComponent } from "./components/nav/item.component";

import { LayoutRouterService } from "./services/router.service";
import { LayoutSidebarService } from "./services/sidebar.service";

export * from "./layout.interface";

export { LayoutComponent } from "./layout.component";
export { LayoutHeaderComponent } from "./components/header.component";
export { LayoutHeaderMenuComponent } from "./components/header/menu.component";
export { LayoutSidebarComponent } from "./components/sidebar.component";
export { LayoutSidebarTogglerComponent } from "./components/sidebar/toggler.component";
export { LayoutSidebarAvatarComponent } from "./components/sidebar/avatar.component";
export { LayoutSidebarBrandComponent } from "./components/sidebar/brand.component";
export { LayoutSidebarHeaderComponent } from "./components/sidebar/header.component";
export { LayoutSidebarFooterComponent } from "./components/sidebar/footer.component";
export { LayoutNavComponent } from "./components/nav.component";
export { LayoutNavItemComponent } from "./components/nav/item.component";

export { LayoutSidebarService } from "./services/sidebar.service";

const LayoutComponents = [
  LayoutComponent,
  LayoutHeaderComponent,
  LayoutHeaderMenuComponent,
  LayoutSidebarComponent,
  LayoutSidebarTogglerComponent,
  LayoutSidebarAvatarComponent,
  LayoutSidebarBrandComponent,
  LayoutSidebarHeaderComponent,
  LayoutSidebarFooterComponent,
  LayoutNavComponent,
  LayoutNavItemComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    ButtonModule,
    DialogModule,
    DrawerModule,
    DropdownModule,
    GenericModule,
    IconModule,
    MediaModule,
    PopoverModule,
    PrintModule,
    TemplateModule,
    ToastModule
  ],
  exports: [LayoutComponents],
  declarations: [LayoutComponents],
  providers: [LayoutRouterService, LayoutSidebarService]
})
export class LayoutModule {}
